import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ViewDaySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ViewDaySVG;
